export default {"src":"/_next/static/media/verifiedIcon.4c7a94c4.svg","height":23,"width":24,"blurWidth":0,"blurHeight":0};